import { CommonModule } from "@angular/common";
import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { NgSelectConfig } from "@ng-select/ng-select";
import { NavbarComponent } from "projects/assist/src/app/_shared/components/layout/navbar/navbar.component";
import { MenuItem } from "projects/assist/src/app/_shared/components/layout/sidenav/models/menuItem";
import { SidenavComponent } from "projects/assist/src/app/_shared/components/layout/sidenav/sidenav.component";
import { GlobalVariables } from "projects/assist/src/app/_shared/services/global.service";
import { AppTemplateComponent } from "projects/assist/src/app/_template/components/app.component";
import { OrganizationService } from "projects/assist/src/app/organisation/services/organization.service";
import { StartsettingsService } from "projects/assist/src/app/organisation/services/startsettings.service";
import { PersonService } from "projects/assist/src/app/person/services/person.service";
import { IntrestGroupService } from "projects/assist/src/app/tasks/services/intrest-group.service";
import { AuthService } from "projects/assist/src/app/users/services/auth.service";
import { UserService } from "projects/assist/src/app/users/services/user.service";
import { NavbarService } from "projects/assist/src/app/_shared/services/navbar.service";
import { forkJoin, of, take } from "rxjs";
import { MemberService } from "../../member/services/member.service";
import { AssistAuthService } from "../../auth/assist-auth.service";
import { UserPersonService } from "../../user/services/user-person.service";
import { UserPersonListDto } from "../../user/models/user-person";
import { MemberStatus } from "../../member/models/member";
@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  standalone: true,
  imports: [CommonModule, SidenavComponent, NavbarComponent, RouterOutlet],
})
export class LayoutComponent extends AppTemplateComponent implements OnInit {
  title = "MijnAssist";
  signedIn = false;
  showmessage = false;
  accessKey = "";

  personKey!: string | null;
  memberKey!: string | null;

  orgKey = "";
  language = "";
  member: boolean = false;

  orgName: string = "";

  menuItems: MenuItem[] = [];

  private previousAccessKey: string = "";

  constructor(
    @Inject(DOCUMENT) private doc: Document,
    private route: ActivatedRoute,
    private userService: UserService,
    private authService: AuthService,
    private config: NgSelectConfig,
    private router: Router,
    private organizationService: OrganizationService,
    private memberService: MemberService,
    private personService: PersonService,
    private intrestService: IntrestGroupService,
    private startsettingsService: StartsettingsService,
    public auth: AssistAuthService,
    private navbarService: NavbarService,
  ) {
    super(doc);
    super.ngSelectTranslate(config);

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        if (this.route.children.length == 0) return;
        this.route.children[0].params.pipe(take(1)).subscribe((params: any) => {
          this.accessKey = params["accessKey"];
          this.orgKey = params["orgKey"];
          this.language = params["language"] ?? "nl";

          // Detecteer persoon wissel - clear menu en persoonsnaam zodat het opnieuw wordt opgebouwd
          if (this.accessKey && this.previousAccessKey !== this.accessKey) {
            this.menuItems = [];
            GlobalVariables.member = null as any;
            this.navbarService.clearPersonName();
          }
          this.previousAccessKey = this.accessKey;

          //get current url
          let url = this.router.url;
          // Reset member flag bij elke navigatie, zodat het correct wordt bepaald op basis van de huidige URL
          this.member = url.includes("member") || url.includes("activity");
          console.log("Load org");
          if (GlobalVariables.startSettings == null) {
            this.startsettingsService.forOrganization(this.orgKey).subscribe((settings) => {
              GlobalVariables.startSettings = settings;
              GlobalVariables.organization = settings.Organization;
            });
          } else if (GlobalVariables.organization == null) {
            GlobalVariables.organization = GlobalVariables.startSettings.Organization;
          }
          if (GlobalVariables.member == null) {
            this.memberService.getByKeyWithFallback(this.accessKey, this.orgKey).subscribe((member) => {
              if (member) {
                GlobalVariables.member = member;
                this.navbarService.setPersonName(member.Person);
              }
            });
          }

          if (this.menuItems.length == 0) {
            if (!url.includes("waitingList")) {
              const isVolunteer = this.personService.isVolunteer(this.accessKey, this.orgKey);
              const memberKey = this.member
                ? of(this.accessKey)
                : this.memberService.getKeyByPerson(this.accessKey, this.orgKey);
              const personKey = this.member
                ? this.personService.getKeyByMember(this.accessKey, this.orgKey)
                : of(this.accessKey);
              const intrestGroups = this.intrestService.getIntrests(this.orgKey);
              const m = this.memberService.getByKeyWithFallback(this.accessKey, this.orgKey);

              forkJoin([isVolunteer, personKey, memberKey, intrestGroups, m]).subscribe(
                ([isVolunteer, personKey, memberKey, intrestGroups, m]) => {
                  this.memberKey = memberKey;
                  this.personKey = personKey;
                    this.menuItems.push({
                      name: "MijnAssist-account",
                      route: `/${this.language}/${this.orgKey}/gebruiker/overzicht`,
                      icon: "fa-lock",
                    });
                  if (m) {
                    GlobalVariables.member = m;
                    this.navbarService.setPersonName(m.Person);
                  }

                  if (this.memberKey && !this.personKey) {
                    this.menuItems.push({
                      name: "Mijn persoonsgegevens",
                      route: `/${this.language}/${this.orgKey}/member/${this.memberKey}/edit`,
                      icon: "fa-user",
                    });
                  }

                  if (this.personKey) {
                    this.menuItems.push({
                      name: "Mijn persoonsgegevens",
                      route: `/${this.language}/${this.orgKey}/person/${this.personKey}/edit`,
                      icon: "fa-user",
                    });

                  }

                  if (this.memberKey) {
                    if (
                      GlobalVariables.member &&
                      GlobalVariables.member.StatusId == MemberStatus.INVITED
                    ) {
                      this.menuItems.push({
                        name: "Mijn lidmaatschap",
                        route: `/${this.language}/${this.orgKey}/member/${this.memberKey}/confirm`,
                        icon: "fa-id-badge",
                      });
                    }
                    if (
                      GlobalVariables.startSettings &&
                      GlobalVariables.startSettings.PayMemberMoneyOnline
                    ) {
                      this.menuItems.push({
                        name: "Mijn lidgeld",
                        route: `/${this.language}/${this.orgKey}/member/${this.memberKey}/pay`,
                        icon: "fa-euro-sign",
                      });
                    }

                    this.menuItems.push({
                      name: "Mijn activiteiten",
                      icon: "fa-regular fa-calendar-days",
                      collapsed: true,
                      subItems: [
                        {
                          name: "Mijn agenda",
                          route: `/${this.language}/${this.orgKey}/member/${this.memberKey}/calendar`,
                          icon: "fa-calendar",
                        },
                        {
                          name: "Mijn inschrijvingen",
                          route: `/${this.language}/${this.orgKey}/activity/${this.memberKey}/subscribe`,
                          icon: "fa-list",
                        },
                      ],
                    });
                  }

                  if (this.personKey) {
                    if (this.orgKey != "ca29a389-f1f7-4f56-9387-be5b366c32f0") {
                      this.menuItems.push(
                        {
                          name: "Mijn vrijwilligerswerk",
                          icon: "fa-handshake-angle",
                          collapsed: true,
                          subItems: [
                            //{
                            //  name: "Mijn beschikbaarheden",
                            //  route: `/${this.language}/${this.orgKey}/vrijwilliger/${this.personKey}/beschikbaarheden`,
                            //  icon: "fa-envelope",
                            //},
                            {
                              name: "Mijn interesses en talenten",
                              icon: "fa-heart",
                              route: `/${this.language}/${this.orgKey}/intrests/${this.personKey}/all`,
                            },
                            {
                              name: "Mijn taken als vrijwilliger",
                              route: `/${this.language}/${this.orgKey}/tasks/${this.personKey}/invites`,
                              icon: "fa-calendar-days",
                            },
                            {
                              name: "Mijn kosten",
                              route: `/${this.language}/${this.orgKey}/expenses/${this.personKey}/all`,
                              icon: "fa-hands-helping",
                            },
                            {
                              name: "Mijn kostennota's",
                              route: `/${this.language}/${this.orgKey}/expenses/${this.personKey}/reports`,
                              icon: "fa-file-invoice-dollar",
                            },
                          ],
                        },
                        {
                          name: "Mijn documenten",
                          icon: "fa-file-alt",
                          collapsed: true,
                          subItems: [
                            {
                              name: "Mijn afsprakennota's",
                              route: `/${this.language}/${this.orgKey}/vrijwilliger/${this.personKey}/afsprakennotas`,
                              icon: "fa-file-contract",
                            },
                            {
                              name: "Mijn kostennota's",
                              route: `/${this.language}/${this.orgKey}/expenses/${this.personKey}/reports`,
                              icon: "fa-file-invoice-dollar",
                            },
                            {
                              name: "Mijn diploma's",
                              route: `/${this.language}/${this.orgKey}/person/${this.personKey}/diplomas`,
                              icon: "fa-diploma",
                            }
                          ],
                        }
                      );
                    }

                    //                  this.personService.isVolunteer(this.personKey, this.orgKey).subscribe((isVolunteer: boolean) => {
                    //                    if (isVolunteer) {
                    //                      this.menuItems.push(
                    //                      {
                    //                        name: 'Mijn kosten',
                    //                        icon: 'fa-receipt',
                    //                        collapsed: true,
                    //                        subItems: [
                    //                          {
                    //                            name: 'Kosten beheren',
                    //                            route: `/${this.language}/${this.orgKey}/expenses/${this.personKey}/all`,
                    //                            icon: 'fa-hands-helping'
                    //                          },
                    //                          {
                    //                            name: 'Kostennota\'s',
                    //                            route: `/${this.language}/${this.orgKey}/expenses/${this.personKey}/reports`,
                    //                            icon: 'fa-file-invoice-dollar'
                    //                          }
                    //                        ],
                    //                      },
                    //                      {
                    //                        name: 'Mijn documenten',
                    //                        icon: 'fa-file-alt',
                    //                        collapsed: true,
                    //                        subItems: [
                    //                          {
                    //                            name: 'Kostennota\'s',
                    //                            route: `/${this.language}/${this.orgKey}/expenses/${this.personKey}/reports`,
                    //                            icon: 'fa-file-invoice-dollar'
                    //                          },
                    //                          {
                    //                            name: 'Afsprakennota\'s',
                    //                            route: `/${this.language}/${this.orgKey}/vrijwilliger/${this.personKey}/afsprakennotas`,
                    //                            icon: 'fa-file-contract'
                    //                          }
                    //                        ],
                    //                      }
                    //                      )
                    //                    }
                    //                  })
                  }
                }
              );
            }

            if (url.includes("waitingListMember")) {
              this.menuItems = [
                {
                  name: "Mijn inschrijvingen",
                  route: `/${this.language}/${this.orgKey}/activity/${this.accessKey}/subscribe/waitingListMember`,
                  icon: "fa-clipboard",
                },
              ];
            }
          }
        });
      }
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.showmessage = true;
    }, 3000);
  }
}
